import { classes, cn } from '../../../utils/class-utils';

interface DividerProps extends React.HTMLAttributes<HTMLHRElement> {
  className?: string;
}

const baseStyles = classes(['h-[1px]', 'border-0', 'bg-[#D6D6D6]/60', 'flex-1']);

export function Divider({ className }: DividerProps) {
  return <hr className={cn(baseStyles, className)} />;
}
